import React, { Component } from "react";
import {
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import moment from "moment";

import {
  getAuditIGPRowData,
  AuditPopRight,
} from "../../store/Audit_Report/actions";

class IGPCardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maximize: true,
    };
  }
  maximizetogle() {
    this.setState((prevState) => ({
      maximize: !prevState.maximize,
    }));
  }
  callNextCard(id) {
    if (this.props.AuditData.length - 1 === this.props.index) {
      this.props.getAuditIGPRowData({
        ScreenID: id,
      });
      this.setState((prevState) => ({
        maximize: !prevState.maximize,
      }));
    }
  }

  render() {
    return (
      <div className={this.state.maximize ? "maximize" : "minimize"}>
        <>
          <Row className="plaseholder">
            <Col>
              <Card className="mb-0 mt-0">
                <CardHeader className="bg-transparent border-bottom ">
                  <h5 className="card-title-18 pt-2 d-inline-block">
                    In Gate Pass List
                  </h5>
                </CardHeader>
                <CardBody className="pt-1">
                  <div className="table-responsive m-0">
                    <Table bordered hover className="mb-0 p-0 table-centered">
                      <thead className="bg-light text-center">
                        <tr>
                          <th className="nowrap">Quotation Code</th>
                          <th className="nowrap">No.of Items</th>
                          <th className="nowrap">No.of PO</th>
                          <th className="nowrap">IGP Date</th>
                          <th className="nowrap">Vehicle No</th>
                          <th className="nowrap">Person Name</th>
                          <th className="nowrap">Remarks</th>
                        </tr>
                      </thead>
                      <tbody className="nowrap">
                        {this.props.obj.data?.length === 0 ? (
                          <tr>
                            <td colspan="7" className="text-center">
                              <span className="font-size-18 text-danger">
                                Data not available
                              </span>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {this.props.obj.data?.map((igp, key) => (
                              <tr key={key} className="text-center">
                                <td>
                                  <Button
                                    type="button"
                                    color="success"
                                    className="waves-effect waves-light orderlist_but m-2 p-1 mb-2"
                                    onClick={() => this.callNextCard(igp.id)}
                                  >
                                    <i className="mdi mdi-file-document mr-1"></i>
                                    {igp.code}
                                  </Button>
                                </td>
                                <td>{igp.items_count} Items</td>
                                <td>{igp.poitems_count} PO</td>

                                <td>
                                  {moment(igp.createdon).format("DD-MM-YYYY")}
                                </td>
                                <td>{igp.vehicleno}</td>
                                <td>{igp.personname}</td>
                                <td>{igp.description}</td>
                              </tr>
                            ))}
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Link
            to="#"
            className="strip"
            onClick={() => {
              this.maximizetogle();
              this.props.AuditPopRight(this.props.index);
            }}
          >
            <div className="MaximizeCard-item mb-2 ">
              <div className="MaximizeCard-title-box d-inline-block">
                <span className="mt-4">In Gate Pass List</span>
              </div>
            </div>
          </Link>
        </>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { AuditData } = state.AuditReport;
  return { AuditData };
};

export default connect(mapStatetoProps, {
  getAuditIGPRowData,
  AuditPopRight,
})(IGPCardList);
